import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

//获取MQTT服务监听列表
export function getServerListenerList(params) {
    return request({
      url: envInfo.bgApp.pumpPath + '/mqtt/server/findServer/list',
      method: 'get',
      params
    })
}

//增加MQTT服务监听
export function createServerListener(params) {
    return request({
      url: envInfo.bgApp.pumpPath + '/mqtt/server/createServer',
      method: 'post',
      data: params
    })
}

//修改MQTT服务监听列表
export function updateServerListener(params) {
    return request({
      url: envInfo.bgApp.pumpPath + '/mqtt/server/uptServer',
      method: 'post',
      data: params
    })
}


//删除MQTT服务监听列表
export function delServerListener(params) {
    return request({
      url: envInfo.bgApp.pumpPath + '/mqtt/server/delServer',
      method: 'post',
      data: params
    })
}

/**
 * 启用MQTT服务
 * @param {Object} params 
 */
export function startServer(params) {
  return request({
    url: envInfo.bgApp.pumpPath + '/mqtt/server/startServer',
    method: 'post',
    data: params
  })
}

/**
 * 停止MQTT服务
 * @param {Object} params 
 */
export function stopServer(params) {
  return request({
    url: envInfo.bgApp.pumpPath + '/mqtt/server/stopServer',
    method: 'post',
    data: params
  })
}
